module.exports = __webpack_public_path__ + "933317c72988ec929b9f1d6a289106a4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_3_0.ttf
// module id = 2253
// module chunks = 2